module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom"
  }, [_c('ul', _vm._l((_vm.list), function(item, index) {
    return _c('li', [_c('p', [_c('img', {
      attrs: {
        "src": item.img
      }
    })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.name))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6935523e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/runda/yinxiao/components/center/centerBottom/index.vue
// module id = 2028
// module chunks = 2